import { render, staticRenderFns } from "./sztd-detail.vue?vue&type=template&id=37763b3a&scoped=true&"
import script from "./sztd-detail.vue?vue&type=script&lang=js&"
export * from "./sztd-detail.vue?vue&type=script&lang=js&"
import style0 from "./sztd-detail.vue?vue&type=style&index=0&id=37763b3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37763b3a",
  null
  
)

export default component.exports